module.exports = __webpack_public_path__ + "static/media/msc-sanlam-medallion.2a3a04c3.csv";